import { useSearchParams } from "react-router-dom";

import { TWorkspace } from "@/types";

import { useAuth } from "./useAuth";

/**
 * The workspace a page about one workspace (/workspace, /subscription)
 * shows: `?workspace=` when it names one of `allowed`, else the user's
 * own. The page links and reloads on it; nothing else in the app reads it.
 */
export const useWorkspaceParam = (allowed: TWorkspace["role"][]) => {
	const { user } = useAuth();
	const [searchParams, setSearchParams] = useSearchParams();

	const options = (user?.workspaces ?? []).filter((w) =>
		allowed.includes(w.role)
	);
	const own = user?.workspaces?.find((w) => w.role === "OWNER") ?? options[0];
	const asked = Number(searchParams.get("workspace"));
	const current = options.find((w) => w.id === asked) ?? own;

	const select = (id: number) => {
		const next = new URLSearchParams(searchParams);
		if (id === own?.id) next.delete("workspace");
		else next.set("workspace", String(id));
		setSearchParams(next, { replace: true });
	};

	return {
		/** Undefined for the user's own: the API's default, no parameter sent. */
		workspaceId: current && current.id !== own?.id ? current.id : undefined,
		current,
		options,
		select,
	};
};
